import { PORTRAITS } from "@/constants/assets";

// Two curated model layouts per orientation for the frost-reveal landing.
export const REVEAL_MODELS = {
  female: [PORTRAITS.female.western, PORTRAITS.female.eastern_european],
  male: [PORTRAITS.male.western, PORTRAITS.male.eastern_european],
};
